import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {CLOSE_PAGE} from "../../../app/import";
import {TGoogleAnalytic, Util} from "../../../app/util";

import {NavRepository} from "../../../repositories/nav-repository";

import {LogadoService} from "../../../providers/logado-service";
import {CarbookService} from '../../../providers/carbook-service';
import {PlasticMenuPage} from "../plastic-menu/plastic-menu";
import {TPaybookTipo, TMethodoTipo, TAction, TCarsale, TProdutoTipo, TConsumoFlag, TPaybookModo, TConviteTipo} from "../../../app/enum";
import {MessageService} from "../../../providers/message-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {ProfileService} from "../../../providers/profile-service";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {EntrakiOpenPage} from '../entraki-open/entraki-open';
import {ProfileMenuPage} from '../profile-menu/profile-menu';
import {ProfileRepository} from '../../../repositories/profile-repository';

@Component({
    selector: 'page-paybook-cart',
    templateUrl: 'paybook-cart.html',
    providers: [ProfileService, ProfileRepository]
})
export class PaybookCartPage {

    TCarsale: any = TCarsale;
    TMethodoTipo: any = TMethodoTipo;
    TConsumoFlag: any = TConsumoFlag;

    config: any;
    logado: any;

    etapa: number;

    carbook: any;
    consumo: any;

    paypisca: any;
    boletocode: string;
    notaDocumento: boolean;
    searching: boolean;

    spotdayID: number;
    deletevar: boolean;

    @ViewChild('inputCopy') inputCopy: ElementRef;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public viewCtrl: ViewController,
                public util: Util, public  profileService: ProfileService,
                public profileRepository: ProfileRepository,
                public messageService: MessageService, public logadoService: LogadoService,
                public navRepository: NavRepository, public carbookService: CarbookService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.consumo = this.navParams.get('consumo');
        this.spotdayID = this.navParams.get('spotdayID');

        this.paypisca = null;
        this.boletocode = '';
        this.notaDocumento = false;
        this.searching = false;

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Carrinho de Compra', '/paybook-cart');

        this.carbookLoad();

    }

    ionViewWillEnter() {


    }


    ionViewDidEnter() {

        let style = this.util.stylesBarColor(this.carbook.Hotspot.Branded.BrandedCora);
        this.util.statusBarColor(style);

    }

    getTitle(): string {

        if (this.carbook.Carsale == TCarsale.csValida) return 'AUTENTICAÇÃO';
        if (this.carbook.Carsale == TCarsale.csPayout) return 'PAYOUT';
        if (this.carbook.Carsale == TCarsale.csMerito) return 'CERTIFICADO';
        if (this.carbook.Carsale == TCarsale.csTicket) return (this.etapa == 0 ? 'EVENTO' : 'CONVITE');

        return '';
    }

    carbookLoad() {

        this.carbook = this.carbookService.getCarrinho();
        console.log(this.carbook);

    }



    /** ************************************************ PAYBOOK ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    entrakiOpen(profile) {

        let object = {etapa: 1, hotspot: this.carbook.Hotspot, userset: null, profileDesk: profile, spotdayID: this.spotdayID, paybookTipo: TPaybookTipo.pbCard, paybookModo: TPaybookModo.pmUser, conviteTipo: TConviteTipo.ctConviteVenda};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
            .subscribe(done => {

                let conviteCash = done.Convite.ConviteSeco+done.Convite.ConviteSuma;

                let consume = {Profile: null, Branded: null, Blended: null, Produto: null, Consumo: null};
                consume.Profile = this.util.deepCopy(profile);
                consume.Branded = {};
                consume.Blended = {};
                consume.Produto = {ProdutoID: 1000000000, ProdutoNome: 'Convite'};
                consume.Consumo = {ConsumoQtde: 1, ConsumoCash: conviteCash, ConsumoLess: 0, AmbientSeta: done};
        
                this.etapa = 1;
                this.consumo = consume;
        
                //let object = {etapa: 1, spotdayID: this.spotdayID, consumo: consume};
                //this.util.navActive(this.navCtrl).push(PaybookCartPage, object, {direction: 'forward'});
                //ESTA NA MODAL, Então... Pega active nav para dar o push!
        
            });

    }

    clienteFind() {

        let ghosterID = this.carbook.Hotspot.Branded.BrandedID;
        this.profileRepository.profileFind(null, 'CPF', ProfileMenuPage, ghosterID)
            .subscribe(line => this.entrakiOpen(line));

    }

    paybookMore() {

        let onOkey = (okey, that, data) => {
            that.dismiss();
            this.paybookFind(okey.inputf.text);
        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'acessofnd', onOkey, null, false, this.carbook.Hotspot.Branded.BrandedCora)};
        this.util.modalopen(ModalActionPage, 'alto', false, objectData).subscribe();

    }

    paybookFind(findfnd: string = '') {

        this.searching = true;
        //Procura...

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ProfileRnid=' + findfnd + '&HotspotID=' + this.carbook.Hotspot.HotspotID + '&PaybookBase=' + 'CURRENT_TIMESTAMP';
        this.profileService.profile(TAction.acGoin, 0, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    if (data.Paybooks) this.carbook.Paybooks.push(data.Paybooks[0]);
                },
                erro => this.util.alertResult(erro)
            );

    }

    consumoMenu(consumo) {

        this.consumo = consumo;
        this.etapa = 1;

    }

    consumoTira(index) {

        if (this.carbook.Carsale == TCarsale.csTicket) {
            this.carbook.Paybooks[0].Consumos.splice(index, 1);
            if (!this.carbook.Paybooks[0].Consumos.length) this.dismiss();
            return;
        }


        let produtoID = this.carbook.Consumes[index].Produto.ProdutoID;
        if (!produtoID) return;

        this.carbook.Paybooks.forEach(PB => {
            //PB.Consumos.forEach()
        });

        this.carbook.Consumes.splice(index, 1);

        //Goback
        if (!this.carbook.Consumes.length) {
            this.navRepository.closePage(this.navCtrl, CLOSE_PAGE).subscribe();
            return;
        }

        this.dismiss();

    }

    consumoJoin() {

        let array = [];

        this.carbook.Paybooks.forEach(PB => {
            PB.Consumos.forEach(CS => {
                let consume = this.carbook.Consumes.find(BK => BK.Produto.ProdutoID == CS.Produto.ProdutoID);

                if (consume)  {
                    consume.Consumo.ConsumoQtde += CS.Consumo.ConsumoQtde;
                    consume.Consumo.ConsumoJoin += (CS.Consumo.ConsumoQtde * (CS.Consumo.ConsumoCash - CS.Consumo.ConsumoLess));
                }

                if (!consume) {
                    console.log('A', CS);
                    consume = this.util.deepCopy(CS);
                    consume.Consumo.ConsumoJoin = (CS.Consumo.ConsumoQtde * (CS.Consumo.ConsumoCash - CS.Consumo.ConsumoLess));
                }

                array.push(consume);
            });
        });

        this.carbook.Consumes = array;

    }

    plasticGate() {

        let onPixe = () => {

        }
        
        let onCard = () => {
            let object = {etapa: 0, readonly: true, rootile: this.logado};
            this.util.modalopen(PlasticMenuPage, 'alto', false, object).subscribe();
        }
        
        let onWale = () => {

        }
        
        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'PIX',      handler: () => onPixe()});
        buttons.push({text: 'Cartão',   handler: () => onCard()});
        buttons.push({text: 'ApplePay', handler: () => onWale()});
        this.util.sheetOpen(buttons, 'PAYOUT');

    }

    carbookDone() {

        //Paybooks não informado
        if (!this.carbook.Paybooks) {
            this.util.alertSimply('Adicione pelo menos um item para prosseguir.', 'Carrinho vazio.');
            return;
        }

        //Forma não selecionada, pisca vermelho
        if (!this.carbook.Payforma) {
            this.paypisca.blink(2);
            return;
        }

        //Boleto Pagamento
        if (this.carbook.Payforma.Methodo.MethodoTipo == TMethodoTipo.mtLeto) this.paymentLeto();

        //Cartão Pagamento
        if (this.carbook.Payforma.Methodo.MethodoTipo == TMethodoTipo.mtCard) this.paymentCard();

    }

    paymentCard() {

        let onPaga = (creditoQtde) => {
            this.carbook.Payforma.CreditoQtde = creditoQtde;

            let objectWal = {etapa: 6, readonly: true, rootile: this.logado, plastic: this.carbook.Payforma.Plastic};
            this.navCtrl.push(PlasticMenuPage, objectWal);
        }

        
        /** OPEN **/
        let buttons: Array<any> = [];
        let cash = this.util.jsSum(this.carbook.Paybooks, ['Consumos', 'Consumo', 'ConsumoCash'], 'ConsumoFlag', [TConsumoFlag.cfLancado]);
        buttons.push({text: 'A Vista', handler: () => onPaga(1)});
        if (true) buttons.push({text: '2 vezes • ' + this.util.dinheiro(this.util.roundUp(cash / 2)), handler: () => onPaga(2)});
        if (true) buttons.push({text: '3 vezes • ' + this.util.dinheiro(this.util.roundUp(cash / 3)), handler: () => onPaga(3)});
        this.util.sheetOpen(buttons, 'PAYOUT');

    }

    paymentLeto() {

        let onPlus = (okey, that, data) => {

            this.util.open('', '_blank', data.Html);

        };

        let onOkey = (okey, that, data) => {

            if (okey.observ) {
                okey.window = 'animeerro';
                okey.corcor = 'CorRoxa';
                okey.header = 'PRONTO';
                okey.titulo = null;
                okey.resumo = 'Novo Boleto pode demorar <b>até 30 min</b> para estar disponível dependendo do seu <b>banco</b>.';
                okey.imagem = this.carbook.Payforma.Methodo.MethodoLogo;
                okey.stores = false;
                okey.action = {name: 'Copiar Código Barras', round: false, small: false, plus: 'Visualizar'};
                okey.observ = null;
                okey.linhas = null;
            }
            else {
                this.boletocode = data.Code;
                this.inputCopy.nativeElement.value = this.util.base64.decode(data.Code);
                this.inputCopy.nativeElement.select();
                this.util.clipboardCopy(this.inputCopy.nativeElement.value, 'Código Barras copiado!');
            }

        };

        //Boleto
        let observ = this.carbookService.payBoleto();

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'animeload', onOkey, onPlus, false, null, observ)};
        objectData.modalinfo.titulo = 'Processando...';
        objectData.modalinfo.imagem = this.carbook.Payforma.Methodo.MethodoLogo;

        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe(
            data => this.util.dismissToViewName(this.navCtrl, 'ConnectPayoutPage'));

    }




    /** ************************************************ CONSUMO ************************************************** **/
    /** ************************************************ etapa-1 ************************************************** **/

    produtoLine(tipo: 'text' | 'info'): string {

        if (tipo == 'text') {
            if (this.carbook.Carsale == TCarsale.csValida) return 'Validate';
            if (this.carbook.Carsale == TCarsale.csPayout) return 'Payout';
            if (this.carbook.Carsale == TCarsale.csMerito) return 'Meritum';
            if (this.carbook.Carsale == TCarsale.csTicket) return 'Ticket';
        }

        if (tipo == 'info') {
            let expira = this.util.dataft(this.consumo.Produto.ProdutoStop, null, 'char', 'yyyy', '/');
            if (this.carbook.Carsale == TCarsale.csValida) return 'Valor de autenticação';
            if (this.carbook.Carsale == TCarsale.csPayout) return this.consumo.ProfileShow;
            if (this.carbook.Carsale == TCarsale.csMerito) return 'Válido até <b>' + expira + '</b>';
            if (this.carbook.Carsale == TCarsale.csTicket && this.consumo.ConsumoCash) return 'Consome <b>' + this.util.dinheiro(this.consumo.ConsumoCash) + '</b>';
        }

        return '';

    }

    consumoNovo() {

        this.carbook.Paybooks[0].Consumos.push(this.consumo);
        this.consumoJoin();
        this.etapa = 0;

    }

    meritumRule() {

        let meritum = this.carbook.Hotspot;
        let object = {etapa: 2, rootile: null, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone};
        this.util.modalopen(MeritumMenuPage, 'quad', false, object).subscribe();

    }




    dismiss() {

        if (this.etapa == 1 && this.carbook.Paybooks[0].Consumos.length) {
            this.etapa = 0;
            return;
        }

        if (!this.viewCtrl.isOverlay) this.navRepository.closePop(this.navCtrl);
        if ( this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        
    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/paybook-cart/paybook-cart.ts